export const uk = {
    placeholder: 'Название продукта',
    search: 'искать'
};
